import { Box } from '@doist/marketist';
import cn from 'clsx';
import css from './product-ui-toggle.module.css';
type ProductUIToggleProps = {
  selected: boolean;
  state: 'idle' | 'hover';
  className?: string;
};
function ProductUIToggle({
  selected,
  state,
  className,
  ...props
}: ProductUIToggleProps) {
  return <Box className={cn(css.container, {
    [css.selected]: selected,
    [css[state]]: state
  }, className)} {...props} data-sentry-element="Box" data-sentry-component="ProductUIToggle" data-sentry-source-file="product-ui-toggle.tsx">
            <Box className={css.toggle} data-sentry-element="Box" data-sentry-source-file="product-ui-toggle.tsx" />
        </Box>;
}
export { ProductUIToggle };